import Events from "@wwdev/bootstrap/Events";

class Item {
	constructor(config) {
		this.config = Object.assign({
			scope: '[data-product-item="scope"]',
			form: '[data-product-item="form"]',
			message: '[data-product-item="message"]',
		}, config);

		this.$scope = $(this.config.scope);

		this.init();
	}

	init() {
		this.addEventListeners();
	}

	addEventListeners() {
		$(document).off('.custom-add-to-cart').on('submit.custom-add-to-cart', `${this.config.scope} ${this.config.form}`, this.handleForm.bind(this));
	}

	handleForm(event) {
		event.preventDefault();
		let $form = $(event.currentTarget);
		let data = $form.serializeObject();

		$.ajax({
			method: 'post',
			url: $form.attr('action'),
			data: data,
			success: (response) => {
				$form.closest(this.config.scope).find(this.config.message).removeClass('d-none');
				Events.trigger('wwdev.reload.indicator');
			}
		});
	}
}

export default Item;